var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M22 26H14C12.8 26 12 25.2 12 24C12 22.8 12.8 22 14 22H22V26ZM34 22H26V26H34C35.2 26 36 25.2 36 24C36 22.8 35.2 22 34 22Z",
    fill: "#2563EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24C44 35 35 44 24 44C13 44 4 35 4 24C4 13 13 4 24 4C35 4 44 13 44 24ZM34 22H26V14C26 12.8 25.2 12 24 12C22.8 12 22 12.8 22 14V22H14C12.8 22 12 22.8 12 24C12 25.2 12.8 26 14 26H22V34C22 35.2 22.8 36 24 36C25.2 36 26 35.2 26 34V26H34C35.2 26 36 25.2 36 24C36 22.8 35.2 22 34 22Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/addCircle.8c294d6a29131f3b4add6520d481a806.svg";
export { ForwardRef as ReactComponent };